import RouteError from '@/components/layout/Page/RouteError.vue';
import RouteLoading from '@/components/layout/Page/RouteLoading.vue';
import { ns } from '@/helpers/store';
import store from '@/store/index';
import { FETCH_USER } from '@/store/types/actions';
import { AUTH } from '@/store/types/namespaces';

function autoLogin(to, _, next) {
  return store.dispatch(ns(AUTH, FETCH_USER))
    .then(() => {
      next({ name: 'accounts' });
    })
    .catch(() => {
      next();
    });
}

export default [
  {
    path: 'logout',
    name: 'logout',
    component: () => import(/* webpackChunkName: "user-section" */ '@/components/pages/user/User/LogoutPage.vue'),
    meta: { title: 'Logout', public: true },
  },
  {
    path: 'login',
    name: 'login',
    component: () => import(/* webpackChunkName: "user-section" */ '@/components/pages/user/User/LoginPage.vue'),
    meta: { title: 'Login', public: true },
    beforeEnter: autoLogin,
  },
  {
    path: 'register',
    name: 'register',
    component: () => import(/* webpackChunkName: "user-section" */ '@/components/pages/user/User/RegisterPage.vue'),
    meta: { title: 'Register', public: true },
    beforeEnter: autoLogin,
  },
  {
    path: 'join',
    name: 'join',
    component: () => import(/* webpackChunkName: "user-section" */ '@/components/pages/user/User/RegisterPage.vue'),
    meta: { title: 'Join', public: true },
    beforeEnter: autoLogin,
  },
  {
    path: 'verify',
    name: 'verify',
    component: () => import(/* webpackChunkName: "user-section" */ '@/components/pages/user/User/Verify.vue'),
    meta: { title: 'Verify account', public: true },
  },
  {
    path: 'accounts',
    name: 'accounts',
    component: () => import(/* webpackChunkName: "user-section" */ '@/components/pages/user/User/AccountsPage.vue'),
    meta: { title: 'Your accounts', public: false },
  },
  {
    path: 'verify-email',
    name: 'verify-email',
    component: () => import(/* webpackChunkName: "user-section" */ '@/components/pages/user/User/VerifyEmail.vue'),
    meta: { title: 'Verify email', public: true },
  },
].map((route) => ({
  ...route,
  loading: RouteLoading,
  error: RouteError,
  delay: 200, // Delay before showing the loading component
  timeout: 5000, // The error component will be displayed if a timeout is provided and exceeded
  meta: {
    ...route.meta,
    section: 'User',
    highScale: true,
  },
}));
